export const SidebarData = [
  {
    title: '기본 설정',
    path: '/',
  },
  {
    title: '회원',
    path: '/',
  },
  {
    title: '진열',
    path: '/',
  },
  {
    title: '상품',
    path: '/',

    subNav: [
      {
        title: '상품 리스트',
        path: '/',
      },
      {
        title: '상품 재고 관리',
        path: '/',
      },
      {
        title: '상품 등록',
        path: '/',
        status: 'active',
      },
    ],
  },
  {
    title: '주문',
    path: '/',
  },
  {
    title: '배송',
    path: '/',
  },
  {
    title: '프로모션',
    path: '/',
  },
  {
    title: '혜택',
    path: '/',
  },
  {
    title: '고객 센터 관리',
    path: '/',
  },
  {
    title: '알림',
    path: '/',
  },
];
